import { render, staticRenderFns } from "./CheckoutElementPublish.vue?vue&type=template&id=d8808e08&"
import script from "./CheckoutElementPublish.vue?vue&type=script&lang=ts&"
export * from "./CheckoutElementPublish.vue?vue&type=script&lang=ts&"
import style0 from "./CheckoutElementPublish.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports